export default __webpack_public_path__ + "static/media/day.667f6f23.svg";